<template>
  <div id="website">
    <div v-if="loading" class="loading">
      <double-bounce :background="primaryColor" size="80px"></double-bounce>
      <h4 class="loading-message" :style="{color: primaryColor}">Building your experience...</h4>
    </div>
    <img :src="imgUrl" @load="_imageLoaded" v-on:click="$store.dispatch('startWebSDKWithMenuKey')"/>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { debounce } from '../services/helpers.service';
import { DoubleBounce } from 'vue-loading-spinner'

export default {
  name: 'Demo',
  components: { DoubleBounce },
  data () {
    return {
      loading: true,
      imgUrl: null
    }
  },
  computed: {
    ...mapState(['userEmail', 'webSDKinitilized']),
    ...mapGetters(['currentPage', 'primaryColor'])
  },
  watch: {
    currentPage(){
      this.imgUrl = null;
      this.loading = true;
      this._changePage();
    },
    '$route.params.slug'(newVal) {
      if(newVal && newVal !== this.currentPage['slug']){
        this.$store.commit('changeToPage', newVal)
      }
    }
  },
  async created() {
    window.addEventListener('resize', this._handleWindowResize);
    this._changePage();
  },
  destroyed () {
    window.removeEventListener('resize', this._handleWindowResize);
  },
  methods: {
    async _getBackgroundUrl() {
      const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

      let response = await fetch(`/api/get-screenshot-url`, {
        headers: { 'Content-Type': 'application/json' },
        method: "POST",
        body: JSON.stringify({
          url: this.currentPage['url'],
          width: width,
          userAgent: navigator.userAgent,
          delay: this.currentPage['delay'] || 2000 }) // 2000ms is default screenshot delay
      });
      let { image } = await response.json();
      this.imgUrl = image;
    },
    _debounceGetBackgroundUrl: debounce(function(){ this._getBackgroundUrl(); }, 500),
    _handleWindowResize(){
      this.imgUrl = null;
      this.loading = true;
      this._debounceGetBackgroundUrl();
    },
    _imageLoaded() {
      this.loading = false;
      if (!this.webSDKinitilized) this.$store.dispatch('initilizeWebSDK');
    },
    _changePage() {
      this.$router.push(`/${this.currentPage['slug']}`)
      this._getBackgroundUrl();
    }
  }
}
</script>

<style scoped>
  #website{
    height: 100vh;
    width: 100vw;
    overflow-y: scroll;
  }

  .loading{
    height: 100vh;
    width: 100vw;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .loading-message{
    margin-top: 50px;
    font-size: 30px;
    font-weight: 300;
    text-align: center;
  } 

  img {
    width: 100%;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/Demo.vue